import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';
export const createBorderColorPropsSDKFactory = buildColorPropsSDKFactoryCreator('borderColor');
//# sourceMappingURL=borderColorPropsSDKFactory.js.map